import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const lightboxBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Lightbox",
  inputs: [
    {
      name: "isOpen",
      type: "boolean",
      helperText: "Set to true to open the modal when page is initially loaded",
      localized: false,
    },
    {
      name: "showFirstImage",
      type: "boolean",
      helperText:
        "Renders the first image in lightbox, otherwise doesn't render anything and needs to be bind to some element by click event.",
      localized: false,
    },
    {
      name: "lightboxId",
      type: "string",
      required: true,
      defaultValue: "lightbox-default",
      helperText:
        'Unique Id used to open the lightbox modal (set event with "Open Lightbox" action)',
      localized: false,
    },
    {
      name: "closeAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
    {
      name: "leftArrowAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
    {
      name: "rightArrowAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
  ],
  shouldReceiveBuilderProps: {
    builderContext: true,
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  childRequirements: {
    component: "Image",
    message: "Lightbox supports only images!",
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      meta: {
        localizedTextInputs: ["alt"],
      },
      component: {
        name: "Image",
        options: {
          source: "aprimo",
          alt: "Placeholder",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png",
        },
      },
    },
  ],
};
